import React, { useEffect, useRef, useState } from "react";
// import Cross from "../../../Assets/Img/Group 208.png";
import PersonalInfo from "./Personalinfo";
import PostData from "../../../Api/PostData";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2'
import './style.css'
import GetData from "../../../Api/GetData";
import analytics from '../../../firebase.config'
import { getAnalytics, logEvent } from "firebase/analytics";
import { Tooltip } from 'antd';
import Icon from '@ant-design/icons';
import Disclaimer from "../../Atoms/Disclaimer";
const FileUploading = ({
  handleDrctChange,
  prevStep,
  nextStep,
  handleChange,
  values,
  removeFile,
  getSaveDocuments

}) => {
  const [sendingSaveReq, setsendingSaveReq] = useState(false);
  const [imageUrl, setimageUrl] = useState([]);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [backAndContinueBtnStatus, setBackAndContinueBtnStatus] = useState(false);
  function getSecondPart(str) {
    if (str) {
      return str.split("/")[1];
    }
    else {
      return "pdf"
    }
  }

  const history = useNavigate();
  // useEffect(() => {

  //   getFileData()
  // }, [])
  var signedEmail = JSON.parse(localStorage.getItem("user")).email;
  var moveToOtpScreenOtpRejected = localStorage.getItem("editFormStatusForReturnOnOtp")
  var editFormStatus = localStorage.getItem("editFormStatus");
  var remitanceValue;
  var remitanceName;
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])






  var CNICFileBackName;
  var CNICFileFrontName;
  var sendSalerySlipName1;
  var ProofRelationFileName;

  var CNICFileUnCompressesFrontNamevar;
  var CNICFileUnCompressedBackNamevar
  var ProofRelationFileUnCompressedvar;
  var PermanentProofRelationFileparam;
  var MailingProofRelationFileparam;
  const openSaveExitModel = () => {

    Swal.fire({
      title: 'You’re almost there!',
      text: "Are you sure you want to exit the account opening form? It only takes a couple of minutes to finish.",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#e5386a',
      // cancelButtonColor: '#d33',
      cancelButtonText: "Continue",
      // showDenyButton: true,
      // showCancelButton: true,
      confirmButtonText: 'Exit',
      // denyButtonText: `Don't save`,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {

      if (result.isConfirmed == true) {

        if (moveToOtpScreenOtpRejected == 'true' || editFormStatus == 'true') {
          history("/Otp");
        }
        else {
          history("/");
        }

      }
    })
    // Get the modal
    // var modal = document.getElementById("SaveExitModal");

    // // Get the <span> element that closes the modal
    // var span = document.getElementsByClassName("close");
    // // When the user clicks the button, open the modal
    // modal.style.display = "block";

    // // When the user clicks on <span> (x) or Close, close the modal

    // for (let i = 0; i < span.length; i++) {
    //   console.log(span, span[i]);
    //   span[i].onclick = function () {
    //     modal.style.display = "none";
    //   };
    // }
    // // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {

    //   if (event.target == modal) {
    //     logout()
    //     modal.style.display = "none";

    //   }
    // };
  };

  const open = () => {

    // window.location.href = imageUrl

    // downloadPDF(pdf) {
    const linkSource = imageUrl;
    // const linkSource = `data:application/pdf;base64,${imageUrl}`;
    const downloadLink = document.createElement("a");
    const fileName = "vct_illustration.pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();

  }






  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader?.readAsDataURL(img);
  }

  function beforeUpload(file) {
    // const isJPG = file.type === 'image/jpeg';
    // if (!isJPG) {
    //   message.error('You can only upload JPG file!');
    // }
    const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error('Image must smaller than 2MB!');
    // }
    return isLt2M;
  }

  const handleChange1 = (info) => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      handleDrctChange("ProofRelationFile", info.file.originFileObj)

      getBase64(info.file.originFileObj, imageUrl => setimageUrl(imageUrl));
    }
  }
  const logout = () => {

    localStorage.clear();
    history("/");
    // modal.style.display = "none";
  }


  const handleBackBtn = () => {
    logEvent(analytics, 'aof_docs_press_back');
    handleDrctChange('step', 3)
  }

  const SaveDocuments = (paramVal) => {
    if (values?.AdditionalDocumentArray?.length) {
      let fileResponse1

      console.log('additionla documnet is===========>>>', values?.AdditionalDocumentArray)

      values?.AdditionalDocumentArray?.forEach((element, index) => {

        if (element?.file) {

          fileResponse1 = PostData.FileAndImageUpload(element?.file, setError, true);
          fileResponse1.then((value) => {

            // let promise = new Promise((resolve, reject) => {

            console.log(value?.data?.fileName, 'values?.AdditionalDocumentArray is ----->>', value)

            let obj = {
              uid: JSON.parse(localStorage.getItem("user"))?.user_id,
              name: value?.data?.fileName,
              description: "description",
              title: element?.name
            }

            PostData.SendDocuments(obj).then((val) => {
              console.log('val is ----->>', val)

              getSaveDocuments()
              if (index == values?.AdditionalDocumentArray?.length - 1) {
                submitForm(paramVal)
              }
            })

            // })
            // promise.then(data => {
            //   if (data) {+
            //     submitForm(paramVal)
            //   }
            // })


          })
        }
        else {

          if (index == values?.AdditionalDocumentArray?.length - 1) {
            submitForm(paramVal)
          }
        }
      })
    }
    else {

      submitForm(paramVal)
    }
  }

  const SaveSubmit = (e, paramVal) => {

    e?.preventDefault();
    // if (paramVal == 'continue') {
    //   e?.preventDefault();
    // }

    localStorage.setItem("save&exist", "true");
    // e?.preventDefault();
    // console.log(JSON.parse(localStorage.getItem('user')).uid)



    if (!values.documentTitle) {
      if (paramVal == 'save') {
        setsendingSaveReq(true)
      } else {
        setBackAndContinueBtnStatus(true)
      }




      if (values.CNICFileBack || values.CNICFileFront || values.SalerySlip || values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

        let fileData = [
          values.CNICFileBack,
          values.CNICFileFront,
          values.SalerySlip,
          values.ProofRelationFile,
          values.CNICFileUnCompressesFrontName,
          values.CNICFileUnCompressedBackName,

          values?.PermanentProofRelationFile,
          values?.MailingProofRelationFile,
          values?.ProofRelationFileUnCompressed
        ]

        let fileResponse

        let counter = 0

        fileData.forEach((element, index) => {
          fileResponse = PostData.FileAndImageUpload(element, setError, true);
          fileResponse.then((value) => {


            let promise = new Promise((resolve, reject) => {


              if (index == 0) {
                CNICFileBackName = value?.data?.fileName
                counter += 1;
              }
              else if (index == 1) {
                CNICFileFrontName = value?.data?.fileName
                counter += 1;

              }
              else if (index == 2) {
                sendSalerySlipName1 = value?.data?.fileName
                console.log('salary slip------------>>>>>>>>>>>', value)
                counter += 1;
              }
              else if (index == 3) {
                ProofRelationFileName = value?.data?.fileName
                counter += 1;

              }
              else if (index == 4) {
                CNICFileUnCompressesFrontNamevar = value?.data?.fileName
                counter += 1;

              }
              else if (index == 5) {
                CNICFileUnCompressedBackNamevar = value?.data?.fileName
                counter += 1;

              }
              else if (index == 6) {
                PermanentProofRelationFileparam = value?.data?.fileName
                counter += 1;

              }
              else if (index == 7) {
                MailingProofRelationFileparam = value?.data?.fileName
                counter += 1;
              }
              else if (index == 8) {
                ProofRelationFileUnCompressedvar = value?.data?.fileName
                counter += 1;
              }

              if (counter == 9) {
                console.log('suycces =====')
                resolve('success')
              }
            })
            promise.then(data => {
              if (data) {
                // submitForm(paramVal)
                SaveDocuments(paramVal)
              }
            })


          })

        })








        // let fileResponse
        // fileData.forEach((element, index) => {
        //   console.log('file', element, index)
        //   fileResponse = PostData.FileAndImageUpload(element, setError, true);
        //   fileResponse.then((value) => {

        //     console.log('file save respons eis ============>>>>', value)
        //     if (index == 0 && values.CNICFileBack) {
        //       CNICFileBackName = value?.data?.fileName
        //       submitForm(paramVal)


        //     }
        //     else if (index == 1 && values.CNICFileFront) {
        //       CNICFileFrontName = value?.data?.fileName
        //       submitForm(paramVal)

        //     }
        //     else if (index == 2 && values.SalerySlip) {
        //       sendSalerySlipName1 = value?.data?.fileName

        //       submitForm(paramVal)
        //     }

        //     else if (index == 3 && values.ProofRelationFile) {
        //       ProofRelationFileName = value?.data?.fileName

        //       // submitForm(paramVal)
        //     }
        //     else if (index == 4 && values.CNICFileUnCompressesFrontName) {
        //       CNICFileUnCompressesFrontNamevar = value?.data?.fileName


        //       submitForm(paramVal)
        //     }
        //     else if (index == 5 && values.CNICFileUnCompressedBackName) {
        //       CNICFileUnCompressedBackNamevar = value?.data?.fileName

        //       submitForm(paramVal)
        //     }




        //   })
        // })
      }
      else {
        // submitForm(paramVal)
        SaveDocuments(paramVal)
      }

    }

  };
  const submitForm = (paramVal) => {
    console.log(CNICFileBackName, 'save -------------', values)
    console.log(CNICFileFrontName, ' CNICFileFrontName -------------', values?.CNICFileBackName)



    if (paramVal == 'save') {
      logEvent(analytics, 'aof_docs_press_save_and_exit');
    }
    else {
      logEvent(analytics, 'aof_docs_press_continue');
    }

    // let obj = {
    //   provinceList: values?.residentiaProvinceList,
    //   cityList: values?.residentialCitiesList
    // }
    let params = {
      uid: JSON.parse(localStorage.getItem("user"))?.user_id,
      status: false, // status true for submition and false for save and exist
      RelationUS: values?.USResident,
      NonRelationUSPAK: values?.TaxPayer,
      RelationOrganization: values?.AssoiciatedEmployee,
      EarnIncome: values?.EarnIncome,
      // below section for Personal  Detail
      ACCOUNT_TYPE: values?.Type?.value,
      ACCOUNT_TYPE_KEY: values?.Type?.children,
      //ACCOUNT_TYPE: 'NKA',
      //ACCOUNT_TYPE_KEY: 'Normal Account',
      SALUTATION: values?.Salutations.value,
      SALUTATION_KEY: values?.Salutations?.children.toUpperCase(),
      firstName: values?.firstName,
      lastName: values?.lastName,
      PLACE_OF_BIRTH: values?.placeOfBirth,
      GENDER: values?.Gender,
      MARITAL_STATUS: values?.MaritalStatus,
      RELATIONSHIP1: values?.Relation?.value,
      RELATIONSHIP1_KEY: values?.Relation?.children,
      FATHER_HUSBAND_NAME: values?.RelativeName,
      DATE_OF_BIRTH: values?.BirthDay,
      NATIONALITY: values?.Citizenship?.value,
      NATIONALITY_KEY: values?.Citizenship?.children,
      residentialStatus: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "02" : "01",
      RESIDENT_KEY: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "Non-Resident" : "Resident",
      // Residential Adddrss feilds start
      PERMANENT_ADDRESS_1: values?.Apt,
      PERMANENT_ADDRESS_2: values?.street,
      // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.iso3,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,

      PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
      MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.country?.label ? values?.country?.label : values?.country?.iso3 || values?.country?.iso2,

      // Xb: obj ,


      // OTHERCITY_TOWN_VILLAGE: values?.otherCities,
      // Residential Adddrss feilds start

      // Mailing Adddrss feilds start
      Xd: values?.MailingAddress == false ? "true" : "false",
      MAILING_ADDRESS_2: values?.MailingAddress == false ? values?.Mailstreet : values?.street,
      MAILING_ADDRESS_1: values?.MailingAddress == false ? values?.MailApt : values?.Apt,
      // MAILING_ADDRESS_3: values?.MailingAddress == false ? (values?.mailCountry?.iso3 || values?.mailCountry?.label) : values?.country?.iso3,



      COUNTRY: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ?
          values?.mailCountry?.iso3 : values?.mailCountry?.iso2
        : (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2,




      // COUNTRY_KEY: values?.country?.label || values?.country?.children,
      COUNTRY_KEY: values?.mailCountry?.label || values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,




      CITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ? values?.MailCity?.City_Code || values?.MailCity?.label : '' :

        (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      CITY_TOWN_VILLAGE_KEY: values?.MailingAddress == false ? values?.MailCity?.label : values?.City?.label,


      PROVINCE_STATE: values?.MailingAddress == false ?

        ((values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan')
          ? values?.MailProvinces?.Province_code || values?.MailProvinces?.state_code : '')


        : (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',

      PROVINCE_STATE_KEY: values?.MailingAddress == false ? values?.MailProvinces?.label : values?.Provinces?.label,
      OTHERPROVINCE_STATE: values?.MailingAddress == false ? (values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailProvinces?.label : "" : (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',
      OTHERCITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        ((values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailCity?.label : "") :

        (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      // permanent country list

      PERMANENT_COUNTRY: (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2 || values?.country?.iso3,
      COUNTRY1_KEY: values?.country?.label || values?.country?.children,
      PERMANENT_PROVINCE: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PROVINCE_KEY: values?.Provinces?.label,
      PERMANENT_CITY_TOWN: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.City?.City_Code || values?.City?.label,
      PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,

      PERMANENT_OTHERPROVINCE: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PERMANENT_OTHERCITY_TOWN: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.City?.City_Code ? values?.City?.City_Code : values?.City?.label,
      EMPLOYER_ADDRESS: values?.EmployStreet ? values?.EmployStreet : "",






      email: values?.email ? values?.email : signedEmail,
      // PERMANENT_CELL_NO: "03" + values?.Number.slice(-9),

      PROOF_OF_ADDRESS: values?.PermanentProofOfAddressCheckbox == false ? (values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : PermanentProofRelationFileparam ? PermanentProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_TYPE: values?.PermanentProofOfAddressCheckbox == false ? (values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "") : '',

      // PROOF_OF_ADDRESS_MAILING: values.MailingProofRelationFileName ? values.MailingProofRelationFileName : '',
      // PROOF_OF_ADDRESS_MAILING_TYPE: values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : '',

      PROOF_OF_ADDRESS_MAILING: values?.MailingProofOfAddressCheckbox == false ? (values.MailingProofRelationFileName ? values.MailingProofRelationFileName : MailingProofRelationFileparam ? MailingProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_MAILING_TYPE: values?.MailingProofOfAddressCheckbox == false ? (values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : "") : '',

      // PROOF_OF_ADDRESS: values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : '',
      // PROOF_OF_ADDRESS_TYPE: values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "",

      // PROOF_OF_ADDRESS_MAILING: values.MailingProofRelationFileName ? values.MailingProofRelationFileName : '',
      // PROOF_OF_ADDRESS_MAILING_TYPE: values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : '',


      PERMANENT_CELL_NO: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),
      PERMANENT_EMAIL: values?.email ? values?.email : signedEmail,
      relationWithMobileNo: values?.CellPhone,
      number: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),
      // number: "03" + values?.Number.slice(-9),
      // RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',
      // RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.value : '1',

      RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.value : '1',
      RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',

      RELATIVE_NAME: values?.CellPhone == 2 ? values?.ProofRelationName : '',
      relativeCNIC: values?.CellPhone == 2 ? ((values?.proofRelation.children == 'Self' || values?.proofRelation.children == 'Company') ? '' : values?.RelativeCNIC) : '',
      // RELATIVE_PROOF: values.ProofRelationFileName ? values.ProofRelationFileName : '',

      RELATIVE_PROOF: values?.CellPhone == 2 ? (values.ProofRelationFileName ? values.ProofRelationFileName : ProofRelationFileName) : "",
      RELATIVE_PROOF_UC: ProofRelationFileUnCompressedvar ? ProofRelationFileUnCompressedvar : values?.ProofRelationFileNameUC ? values?.ProofRelationFileNameUC : '',
      NAME_NMN: values?.addnominee == true ? (values?.NomineeName ? values?.NomineeName : '') : '',
      IDENTIFICATION_NMN: values?.addnominee == true ? (values?.NomineeIDType ? values?.NomineeIDType : '') : '',
      RELATIONSHIP_NMN: values?.addnominee == true ? (values?.NomineeRelation?.value ? values?.NomineeRelation?.value : '') : '',
      RELATIONSHIP_NMN_KEY: values?.addnominee == true ? (values?.NomineeRelation?.children ? values?.NomineeRelation?.children : '') : '',
      CNIC_NMN: values?.addnominee == true ? (values?.NomineeIDNumber ? values?.NomineeIDNumber : '') : '',
      CNIC_ISSUE_DATE_NMN: values?.addnominee == true ? (values?.NomineeIssueDate ? values?.NomineeIssueDate : '') : '',
      CNIC_EXPIRY_DATE_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate) : '',
      CNIC_LIFETIME_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false") : '',

      // *********************   below section for Income Detail  ***************************************
      idType: values?.IDType,
      CNIC: values?.CNIC,
      issueDate: values?.IssueDate,
      DATE_OF_EXPIRY: values?.lifeTimeExpiry == true ? '' : values?.ExpiryDate,
      LIFETIME_KEY: values?.lifeTimeExpiry ? JSON.stringify(values?.lifeTimeExpiry) : "false",
      IBAN: values.IBAN,
      BANK_NAME: values?.BankName,
      // employmentStatus: values.EmploymentStatus,
      EMPLOYER_NAME: values?.CompName,
      OCCUPATION: values?.BussType?.value ? values?.BussType?.value : "",
      OCCUPATION_KEY: values?.BussType?.children ? values?.BussType?.children : "",
      JOB_TITLE: values?.JobTitle,
      Department: values?.Department,
      OTHER_OCCUPATION: values?.BussType?.children == "Other" ? values?.OtherOccupation : '',
      // for Now Employee Apartment is removed from income detail section
      // employeeApt:values?.EmployApt,

      GROSS_ANNUAL_INCOME: values?.AnnualIncome?.value ? values?.AnnualIncome?.value : "",
      GROSS_ANNUAL_INCOME_KEY: values?.AnnualIncome?.children ? values?.AnnualIncome?.children : "",
      ZAKAT_STATUS: values?.Zakat?.value ? values?.Zakat?.value : "",
      ZAKAT_STATUS_KEY: values?.Zakat?.children ? values?.Zakat?.children : "",
      // Remittance: values?.BasisOfRemittance?.value ? values?.BasisOfRemittance?.value : "",
      // RemittanceKey: values?.BasisOfRemittance?.children ? values?.BasisOfRemittance?.children : "",
      Remittance: remitanceValue,
      RemittanceKey: remitanceName,
      SOURCE_OF_INCOME: values?.sourceofincome, // this feild still need to be manage on screen not in figma
      UKN: values?.UKN,
      MOTHER_MAIDEN_NAME: values?.MOTHER_MAIDEN_NAME,
      // ************************* below Section for Documentations *****************************************


      CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : CNICFileFrontName ? CNICFileFrontName : "",

      CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : CNICFileBackName ? CNICFileBackName : "",

      CNIC_FRONT_UC: CNICFileUnCompressesFrontNamevar ? CNICFileUnCompressesFrontNamevar : values?.CnicFrontUC ? values?.CnicFrontUC : '',

      CNIC_BACK_UC: CNICFileUnCompressedBackNamevar ? CNICFileUnCompressedBackNamevar : values?.CnicBackUC ? values?.CnicBackUC : '',


      ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : sendSalerySlipName1 ? sendSalerySlipName1 : "",

      //  below Section for Terms and conditions
      TERMS_CONDITIONS: "Y", //what to send in this?





      // Not found for following


      proofofRelationship: "",
      Client_Code: "",
      TELEPHONE_OFFICE: "",
      TELEPHONE_RESIDENCE: "",
      FAX: "",
      // PERMANENT_COUNTRY: values?.mailCountry?.value,

      PERMANENT_TELEPHONE_OFFICE: "",
      PERMANENT_TELEPHONE_RESIDENCE: "",
      PERMANENT_FAX: "",
      // OTHER_OCCUPATION: "",
      EMP_ADD_PROOF: "",
      SIGNATURE_PROOF: "",
      // TERMS_CONDITIONS: "",
      ProofofIBAN: "",
      // ZAKAAT_DECLARATION: "",
      // Remittance: "",

      // These are to be send empty for Now
      Salutation_ATR: "",
      CLIENT_NAME_ATR: "",
      IDENTIFICATION_ATR: "",
      CNIC_ATR: "",
      CNIC_EXPIRY_DATE_ATR: "",
      CNIC_LIFETIME_ATR: "",
      Mobile_ATR: "",
      Email_ATR: "",
      Mailing_ADDRESS_ATR_1: "",
      Mailing_ADDRESS_ATR_2: "",
      Mailing_ADDRESS_ATR_3: "",
      Mailing_Country_ATR: "",
      Mailing_Province_ATR: "",
      Other_Mailing_Prov_ATR: "",
      Mailing_CITY_ATR: "",
      Other_Mailing_CITY_ATR: "",
      Landline_ATR: "",
      FAX_ATR: "",
      COMP_STATUS: "false"
    };

    console.log(sendSalerySlipName1, 'params -------------', params)
    axios
      .post("account-details/", params)
      .then((value) => {
        // setsendingReq(false);
        setsendingSaveReq(false)
        setBackAndContinueBtnStatus(false)
        if (paramVal == 'save') {
          if (value.data) {
            openSaveExitModel();
          }
        }
        else {

          nextStep()


        }

      })
      .catch(function (error) {
        // setsendingReq(false);
        setBackAndContinueBtnStatus(false)
        setErrorMessage(true)
        console.log(error.response);
      });

  }
  const inputRef = useRef(null);
  const emptyIt = () => {
    console.log('Before Empty', values?.AdditionalDocumentArray)
    // @ts-ignore (us this comment if typescript raises an error)
    inputRef.current.value = "";
  };
  return (

    <div className="container-fluid px-0 bg-grey-100 py-5">

      <PersonalInfo handleDrctChange={handleDrctChange} values={values} />
      <div className="container px-0">
        <div className="mt-4">
          <div className="px-3">
            <div className="row my-5">
              <div className="col-sm-8">
                <div className="d-inline-flex w-100">
                  <h1 className="fs32 ls4 fw-800 t-grey-800">Documentations</h1>
                </div>
                {/* <p className="fw-400 fs14 t-grey-400">
                  Let�s get your account ready and started. We may require some
                  information in order to verify your identification. All your
                  information and documents are required by law to obtain and
                  verify.
                </p> */}
              </div>
            </div>
            <form onSubmit={(e) => { SaveSubmit(e, 'continue') }} className="mt" id='AOF-form'>
              <div className="row mb-5">
                <div className="col-lg-4 mb-3">
                  <div className="p-4 p-sm-5 p-md-4 p-lg-5 bg-white edge  d-flex flex-column">
                    <p className="fs17 fw-800 t-grey-800 Bold ">CNIC Front & Back Images (Required)</p>
                    {/* <p className="fs14 fw-400 t-grey-200 ls5 mb-4 flex11-auto">
                      NCCPL requires you to provide scanned copy of your National Identity Card front and back separately. You can drag or drop the files below or click upload.
                    </p> */}
                    <div className="row">



                      {values?.CNICFileFrontName ? (
                        <>
                          <div className="d-block d-sm-table">
                            <div className="Circularprogress yellow">

                              <span className="Circularprogress-left">

                                <span className="Circularprogress-bar"></span>
                              </span>
                              <span className="Circularprogress-right">

                                <span className="Circularprogress-bar"></span>
                              </span>
                              <div className="Circularprogress-value t-pink fs12 fw-400">

                                {values?.CNICFileFrontName?.split(".").pop().toUpperCase()}
                              </div>
                            </div>

                            <div className="fileName">
                              {/* <div className="position-absolute ml-55"> */}
                              <div >
                                <p className="m-0 t-grey-600 fs16 fw-500 dotted">

                                  {values?.CNICFileFrontName}
                                </p>

                              </div>
                            </div>
                          </div>
                          <div className="my-3 bg-Pink edge p-1">
                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                              className="mx-auto d-block"
                              onClick={() =>
                                handleDrctChange(
                                  "CNICFileFrontName",
                                  ""
                                )} />
                            {/* <img
                              src={Cross}
                              alt="cross"
                              className="mx-auto d-block"
                              onClick={() =>
                                handleDrctChange(
                                  "CNICFileFrontName",
                                  ""
                                )
                              }
                            /> */}
                          </div>
                        </>) : (<>
                          {values.CNICFileFront ? (
                            <>
                              {Object.keys(values.CNICFileFront).map((x) => {

                                return (
                                  <>
                                    <div className="col-12 my-3">
                                      <div className="d-block d-sm-table">
                                        <div className="Circularprogress yellow">

                                          <span className="Circularprogress-left">

                                            <span className="Circularprogress-bar"></span>
                                          </span>
                                          <span className="Circularprogress-right">

                                            <span className="Circularprogress-bar"></span>
                                          </span>
                                          <div className="Circularprogress-value t-pink fs12 fw-400">
                                            {getSecondPart(
                                              values.CNICFileFront[x].type
                                            ).toUpperCase()}
                                          </div>
                                        </div>

                                        <div className="fileName">
                                          {/* <div className="position-absolute ml-55"> */}
                                          <div >
                                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">

                                              {values.CNICFileFront[x].name}
                                            </p>
                                            <div>
                                              <p className="m-0 t-grey-400 fw-400 fs14 ">

                                                {Math.round(
                                                  values.CNICFileFrontSize / 1024
                                                )}
                                                kb /
                                                {Math.round(
                                                  values.CNICFileFrontSize / 1024
                                                )}
                                                kb
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="my-3 bg-Pink edge p-1"
                                        onClick={() =>
                                          handleDrctChange("CNICFileFront", "")
                                        }>
                                        {/* <img
                                          src={Cross}
                                          alt="cross"
                                          className="mx-auto d-block"
                                        /> */}
                                        <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                          className="mx-auto d-block"
                                        />
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          ) : (
                            <input
                              type="file"
                              name="CNICFileFront"
                              value={values.CNICFileFront}
                              onChange={handleChange}
                              className="custom-file-input front col-12 col-sm-6 col-md-12"
                              accept=".jpg, .jpeg, .png"
                              required={true}
                            />
                          )}
                        </>)}











                      {values?.CNICFileBackName ? (
                        <>
                          <div className="d-block d-sm-table">
                            <div className="Circularprogress yellow">

                              <span className="Circularprogress-left">

                                <span className="Circularprogress-bar"></span>
                              </span>
                              <span className="Circularprogress-right">

                                <span className="Circularprogress-bar"></span>
                              </span>
                              <div className="Circularprogress-value t-pink fs12 fw-400">
                                {values?.CNICFileBackName?.split(".").pop().toUpperCase()}
                              </div>
                            </div>

                            <div className="fileName">
                              {/* <div className="position-absolute ml-55"> */}
                              <div >
                                <p className="m-0 t-grey-600 fs16 fw-500 dotted">

                                  {values?.CNICFileBackName}
                                </p>

                              </div>
                            </div>
                          </div>
                          <div className="my-3 bg-Pink edge p-1">
                            {/* <img
                              src={Cross}
                              alt="cross"
                              className="mx-auto d-block"
                              onClick={() =>
                                handleDrctChange(
                                  "CNICFileBackName",
                                  ""
                                )
                              }
                            /> */}

                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                              className="mx-auto d-block"
                              onClick={() =>
                                handleDrctChange(
                                  "CNICFileBackName",
                                  ""
                                )
                              }
                            />
                          </div>
                        </>) : (<>

                          {values.CNICFileBack ? (
                            <>
                              {Object.keys(values.CNICFileBack).map((x) => {

                                return (
                                  <>
                                    <div className="col-12 my-3">
                                      <div className="d-block d-sm-table">
                                        <div className="Circularprogress yellow">

                                          <span className="Circularprogress-left">

                                            <span className="Circularprogress-bar"></span>
                                          </span>
                                          <span className="Circularprogress-right">

                                            <span className="Circularprogress-bar"></span>
                                          </span>
                                          <div className="Circularprogress-value t-pink fs12 fw-400">
                                            {getSecondPart(
                                              values.CNICFileBack[x].type
                                            ).toUpperCase()}
                                          </div>
                                        </div>

                                        <div className="fileName">
                                          {/* <div className="position-absolute ml-55"> */}
                                          <div >
                                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">

                                              {values.CNICFileBack[x].name}
                                            </p>
                                            <div>
                                              <p className="m-0 t-grey-400 fw-400 fs14 ">

                                                {Math.round(
                                                  values.CNICFileBackSize / 1024
                                                )}
                                                kb /
                                                {Math.round(
                                                  values.CNICFileBackSize / 1024
                                                )}
                                                kb
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="my-3 bg-Pink edge p-1"
                                        onClick={() =>
                                          handleDrctChange("CNICFileBack", "")
                                        }>
                                        {/* <img
                                          src={Cross}
                                          alt="cross"
                                          className="mx-auto d-block"
                                        /> */}
                                        <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                          className="mx-auto d-block"

                                        />
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          ) : (
                            <input
                              type="file"
                              name="CNICFileBack"
                              value={values.CNICFileBack}
                              onChange={handleChange}
                              className="custom-file-input back col-12 col-sm-6 col-md-12"
                              accept=".jpg, .jpeg, .png"
                              required={true}
                            />
                          )}
                        </>)}

                      <div className="upload-cnic-hint">
                        The file uploaded must either be a PNG or JPEG file and must be 5 MB or smaller (---)
                      </div>





















                    </div>

                  </div>
                </div>
                <div className="col-lg-8 mb-3">
                  <div className="p-4 p-sm-5 p-md-4 p-lg-5  bg-white edge h-100 d-flex flex-column">
                    <div className=" d-block proof-of-income">
                      <div>
                        <p className="fs18 fw-800 t-grey-800 Bold  mb8">Proof of Income (Can be submitted later)

                          <Tooltip overlayStyle={{ maxWidth: '350px' }} title={
                            <>
                              <p className="fw-500 fs14 text-white">
                                We require this to comply with anti-money laundering regulations. Your source of income provides us with an idea of how much you can invest. <br /> <br />
                                In case you don't upload it now, a customer support representative will approach you for the
                                necessary documents. Alternatively, you may reach out to customer support later on to submit your proof of income. <br /> <br />
                                UAN: 021 111 639 825 Ext 147 <br />
                                WhatsApp: +92 314 NEXTCAP (6398227) <br />
                                Email: cs@nextcapital.com.pk <br />
                              </p>
                            </>
                          }
                            placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>


                        </p>
                        <p className="fs14 fw-400 t-grey-200 ls5 ">
                          You are required to provide any one of the income proofs listed. We are required to obtain this information as per<br /> SECP regulations.
                        </p>
                      </div>









































                      <div className="mt">


                        {values?.sendSalerySlipName ? (
                          <>
                            <div className="d-block d-sm-table">
                              <div className="Circularprogress yellow">
                                {" "}
                                <span className="Circularprogress-left">
                                  {" "}
                                  <span className="Circularprogress-bar"></span>{" "}
                                </span>{" "}
                                <span className="Circularprogress-right">
                                  {" "}
                                  <span className="Circularprogress-bar"></span>{" "}
                                </span>
                                <div className="Circularprogress-value t-pink fs12 fw-400">
                                  {/* PDF */}
                                  {values?.sendSalerySlipName?.split(".").pop().toUpperCase()}
                                </div>
                              </div>

                              <div className="fileName">
                                <div >
                                  <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                    {" "}
                                    {values?.sendSalerySlipName}
                                  </p>

                                </div>
                              </div>
                            </div>
                            <div className="my-3 cursor bg-Pink edge p-1">

                              <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                className="mx-auto d-block"
                                onClick={() =>
                                  handleDrctChange(
                                    "sendSalerySlipName",
                                    ""
                                  )
                                }
                              />
                            </div>
                          </>) : (<>

                            {values.SalerySlip ? (
                              <>
                                {Object.keys(values.SalerySlip).map((x) => {

                                  return (
                                    <>
                                      <div className="d-block d-sm-table">
                                        <div className="Circularprogress yellow">

                                          <span className="Circularprogress-left">

                                            <span className="Circularprogress-bar"></span>
                                          </span>
                                          <span className="Circularprogress-right">

                                            <span className="Circularprogress-bar"></span>
                                          </span>
                                          <div className="Circularprogress-value t-pink fs12 fw-400">
                                            {getSecondPart(
                                              values.SalerySlip[x].type
                                            ).toUpperCase()}
                                          </div>
                                        </div>

                                        <div className="fileName">
                                          <div >
                                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">

                                              {values.SalerySlip[x].name}
                                            </p>
                                            <div>
                                              <p className="m-0 t-grey-400 fw-400 fs14 ">

                                                {Math.round(
                                                  values.SalerySlipSize / 1024
                                                )}
                                                kb /
                                                {Math.round(
                                                  values.SalerySlipSize / 1024
                                                )}
                                                kb
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="my-3 cursor bg-Pink edge p-1 w30">


                                        <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                          className="mx-auto d-block"
                                          onClick={() =>
                                            handleDrctChange(
                                              "SalerySlip",
                                              ""
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="upload-file-hint mt8">
                                        The file uploaded must either be a PNG, JPEG or PDF file and must be 5 MB or smaller
                                      </div>
                                    </>
                                  );
                                })}
                              </>
                            ) : (
                              <>
                                <input
                                  type="file"
                                  name="SalerySlip"
                                  // value={values?.SalerySlip}
                                  onChange={handleChange}
                                  className="custom-file-input browse w-100"
                                  accept="application/pdf ,.jpg, .jpeg, .png"

                                />
                                <div className="upload-file-hint ">
                                  The file uploaded must either be a PNG, JPEG or PDF file and must be 5 MB or smaller
                                </div>
                              </>
                            )}
                          </>)}
                      </div>






                    </div>
                    <div className=" flex11-auto ">
                      <div className="col-md-7 d-flex ">






                      </div>
                      <div className="col-md-6 d-flex mt">
                        <p className="fs14 fw-500 t-grey-200 ls5 ">
                          <b>Any one</b> the below documents are required
                        </p>





                      </div>
                      <div className="row flex11-auto">
                        <div className="col-md-4 h-100 d-flex flex-column">
                          <ul className=" t-grey-200 fs14 fw-400 ls5 flex11-auto">

                            <li>Salary Slip</li>
                            <li> Employment contract</li>

                            <li> Bank statement (3 months)</li>
                            <li>Rental agreement</li>
                            <li> Pension certificate</li>
                          </ul>
                        </div>
                        <div className="col-md-8 h-100 d-flex flex-column">
                          <ul className="fs14 fw-400 t-grey-200 ls5 flex11-auto">
                            <li>Documents showing the sale of agricultural proceeds (for agriculturists)</li>
                            <li>Dividend warrant</li>
                            <li>Proof of remittance (for freelancers)</li>
                            <li>Client contract (for freelancers and consultants)</li>

                            <li>Any document showing evidence of savings (saving certificate, term certificate, etc)</li>
                            <li>Tax Returns</li>
                          </ul>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>



              {/************************************  additional documnet wqork start  ******************************* */}








              <div className="row my-5">
                <div className="col-sm-8">
                  <div className="d-inline-flex w-100">
                    <h1 className="fs32 ls4 fw-800 t-grey-800">Additional Documents</h1>
                  </div>
                  {/* <p className="fw-400 fs14 t-grey-400">
                  Let�s get your account ready and started. We may require some
                  information in order to verify your identification. All your
                  information and documents are required by law to obtain and
                  verify.
                </p> */}
                </div>
              </div>
              <div className="col-lg-12 mb-3">

                <div className="p-4 p-sm-5 p-md-4 p-lg-5  bg-white edge h-100 row additionalDoc">
                  <div className="col-12 col-lg-6">
                    <p className="fs14 fw-400 t-grey-200 ls5 ">
                      Depending on your submission we may ask you for <br /> additional documents. Please upload these documents <br /> here. <br /> <br />
                      The file uploaded must either be a PNG, JPEG or PDF file <br /> and must be 5 MB or smaller.
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <div className="d-flex">
                        <div className="w-75 pe-2">
                          <input
                            type="text"
                            name="documentTitle"
                            className="form-control"
                            placeholder="Document Title"
                            value={values?.documentTitle}
                            onChange={handleChange}
                            minLength="1"
                            maxLength="120"
                          // title="Only Alphabets are allowed"
                          />

                        </div>
                        <div className="w-25">
                          <input
                            type="file"
                            name="AdditionalDocuments"
                            ref={inputRef}
                            // id="AdditionalDocumentsUpload"
                            // value={values?.SalerySlip}

                            onChange={handleChange}
                            className="custom-file-input browse w-100 justupload"
                            disabled={!values.documentTitle || values?.AdditionalDocumentArray?.length > 4}
                            accept="application/pdf, .jpg, .jpeg, .png"
                            required
                          />
                        </div>
                      </div>
                      <div>
                        <div className="">
                          {values?.AdditionalDocumentsName ? (
                            <>
                              {values?.AdditionalDocumentArray?.map((apiDocumentData, index) => {
                                return (
                                  <>
                                    {/* already saved */}
                                    <div className="d-flex justify-content-between">
                                      <div className="d-block d-sm-table">
                                        <div className="Circularprogress yellow">
                                          {" "}
                                          <span className="Circularprogress-left">
                                            {" "}
                                            <span className="Circularprogress-bar"></span>{" "}
                                          </span>{" "}
                                          <span className="Circularprogress-right">
                                            {" "}
                                            <span className="Circularprogress-bar"></span>{" "}
                                          </span>
                                          <div className="Circularprogress-value t-pink fs12 fw-400">
                                            {/* PDF */}
                                            {apiDocumentData?.file ? getSecondPart(
                                              apiDocumentData?.file[0]?.type
                                            ).toUpperCase() :
                                              apiDocumentData?.name?.split(".").pop().toUpperCase()
                                            }
                                          </div>
                                        </div>
                                        <div className="fileName">
                                          <div >
                                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                              {" "}
                                              {apiDocumentData?.title ? apiDocumentData?.title : apiDocumentData?.name}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="my-3 cursor edge p-1 w30 ">
                                        {index + 1 == values?.AdditionalDocumentArray.length ?
                                          <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                            className="mx-auto d-block yes"
                                            onClick={() => {
                                              emptyIt()
                                              removeFile(apiDocumentData?.id)
                                            }} /> :
                                          <img className="mx-auto d-block  diable-img " src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                          />
                                        }
                                      </div>
                                    </div>
                                  </>
                                )
                              })}
                              {/* <div className="my-3 cursor bg-Pink edge p-1">
<img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
className="mx-auto d-block"
onClick={() =>
handleDrctChange(
"AdditionalDocumentsName",
""
)
}
/>
</div> */}
                            </>) : (<>
                              {values.AdditionalDocumentArray ? (
                                <>
                                  {values.AdditionalDocumentArray.map(x => {
                                    return (
                                      <>
                                        {console.log({ x })}
                                        {/* recently uploaded */}
                                        <div className="d-flex justify-content-between">
                                          {/* <div>
                  <p>{x.name}</p>
                </div> */}
                                          <div className="d-block d-sm-table">
                                            <div className="Circularprogress yellow">
                                              <span className="Circularprogress-left">
                                                <span className="Circularprogress-bar"></span>
                                              </span>
                                              <span className="Circularprogress-right">
                                                <span className="Circularprogress-bar"></span>
                                              </span>
                                              <div className="Circularprogress-value t-pink fs12 fw-400">
                                                {getSecondPart(
                                                  x?.file[0]?.type
                                                ).toUpperCase()}
                                              </div>
                                            </div>
                                            <div className="fileName">
                                              <div >
                                                <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                                  {x?.file[0]?.name}
                                                </p>
                                                <div>
                                                  <p className="m-0 t-grey-400 fw-400 fs14 ">
                                                    {Math.round(
                                                      x?.file[0]?.size / 1024
                                                    )}
                                                    kb /
                                                    {Math.round(
                                                      x?.file[0]?.size / 1024
                                                    )}
                                                    kb
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="my-3 cursor edge p-1 w30">
                                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                              className="mx-auto d-block"
                                              onClick={() =>
                                                removeFile(x.id)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </>
                                    )
                                  })}
                                </>
                              ) : (
                                <>
                                  {/* <input
type="file"
name="AdditionalDocuments"
// value={values?.SalerySlip}
onChange={handleChange}
className="custom-file-input browse w-100"
accept="application/pdf"
/>
<div className="upload-file-hint ">
The file uploaded must either be a PNG, JPEG or PDF file and must be 5 MB or smaller
</div>*/}
                                </>
                              )}
                            </>)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>







              {/* additional documnet work end */}
















              <hr className="t-grey-200"></hr>
              <div className="mb-3 pt-5 row">
                <Disclaimer />

                <div className="col-lg-5 col-xl-4">
                  <div className=" text-end threeButton d-lg-flex justify-content-end">
                    <div className='px-2 d-lg-none mb-2'>
                      <button
                        className="btn-filled fs16 px-2 px-md-3 btnPad disableBtn naviBtn"
                        type="submit"
                        id='FileUploading'
                        // onClick={() => SaveSubmit('continue')}
                        disabled={backAndContinueBtnStatus == true}
                      >
                        {backAndContinueBtnStatus ? (

                          <div className="whitespinner">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                          </div>
                        ) : (
                          <>Continue</>
                        )}
                      </button>
                    </div>
                    <div className="d-flex mb-2 mb-lg-0">
                      <div className='px-2'>
                        <button
                          className="btn-outlined fs16 px-2 px-md-3 disableBtn btnPad"
                          type="button"
                          // onClick={() => handleDrctChange('step', 1)}
                          disabled={backAndContinueBtnStatus == true}
                          onClick={() => handleBackBtn()}
                        >
                          Back
                        </button>
                      </div>
                      <div className='px-2'>
                        <button
                          className="btn-outlined fs16 px-2 px-md-3 disableBtn btnPad"
                          type='button'
                          disabled={backAndContinueBtnStatus == true}
                          onClick={(e) => SaveSubmit(e, 'save')}
                        >
                          {sendingSaveReq ? (
                            <div className="spinner">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          ) : (
                            <>Save & Exit</>
                          )}
                        </button>
                      </div>
                    </div>

                    <div className='px-2 d-none d-lg-block'>
                      <button
                        className="btn-filled fs16 px-2 px-md-3 btnPad disableBtn  naviBtn"
                        type="submit"
                        id='FileUploading2'
                        // onClick={() => SaveSubmit('continue')}
                        disabled={backAndContinueBtnStatus == true}
                      >
                        {backAndContinueBtnStatus ? (

                          <div className="whitespinner">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                          </div>
                        ) : (
                          <>Continue</>
                        )}
                      </button>
                    </div>
                  </div>


                  {backAndContinueBtnStatus &&
                    <div className="text-end">

                      <p className="fw-400 fs14 t-grey-400 pt3">

                        Please wait while the documents upload

                      </p>
                    </div>
                  }

                  {errorMessage &&
                    <div className="text-end pt 3">

                      <p className="fw-400 fs14 t-red">

                        An unknown error has occurred

                      </p>
                    </div>

                  }
                </div>




                {/* <div className="col-lg-5 col-xl-4 text-end">
                  <button
                    className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type='button'
                    onClick={() => SaveSubmit('save')}
                  >
                    {sendingSaveReq ? (
                      // <div className="spinner-border t-pink" role="status">
                      //   <span className="visually-hidden">Loading...</span>
                      // </div>
                      <div className="spinner">
                      <div className="bounce1"></div>
                      <div className="bounce2"></div>
                      <div className="bounce3"></div>
                    </div>
                    ) : (
                      <>Save & Exit</>
                    )}
                  </button>
                  <button
                    className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type="button"
                    // onClick={() => handleDrctChange('step', 3)}
                    onClick={() => handleBackBtn()}
                  >
                    Back
                  </button>
                  <button
                    className="btn-filled fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type="submit"
                  // onClick={() => SaveSubmit('continue')}
                  >
                    Continue
                  </button>
                </div> */}
              </div>
            </form>
            <p className="text-danger fs12 text-end">{error}</p>
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              id="SaveExitModal"
            >
              <div className="modal-dialog centerr" role="document">
                <div className="modal-content">
                  <div className="modal-header p-0">
                    <h5 className="modal-title t-pink">Information Submited</h5>

                    <span className="close cross">&times;</span>
                  </div>
                  <div className="modal-body px-0">

                    <p className="fw-500 fs16 ms-auto t-grey-400 cursorPointer">
                      Thank You your information has been saved.
                    </p>
                  </div>
                  <div className="modal-footer px-0">
                    <NavLink to="/Dashboard">
                      <button
                        type="button"
                        className="btn-outlined fs16 px-3 py-2 mx-2 close"
                        data-dismiss="modal"
                      // onClick={() => logout()}
                      >
                        OK
                      </button>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploading;

const HelpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 15C9.45 15 9 14.55 9 14V10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10V14C11 14.55 10.55 15 10 15ZM11 7H9V5H11V7Z" fill="#D2D6DC" />
  </svg>

)

